<template>
  <div class="ui-pop" v-show="show">
    <div class="ui-mask"></div>
    <div class="ui-modal">
      <h3 class="title">{{$t("tip")}}</h3>
      <input type="password" v-model="psw">
      <div class="btns">
        <a class="ui-btn gray" @click="closePop">{{$t("cancel")}}</a>
        <a class="ui-btn" @click="goPay">{{$t("user.gopay")}}</a>
      </div>
    </div>
  </div>
</template>
<script>
import {orderCourse, payOrder} from '@/service/studentApi.js'
import moment from 'moment'
export default {
  props: ['show', 'info', 'timeArr', 'type','courseIds','courseList'],
  data(){
    return {
      psw: ''
    }
  },
  methods: {
    async goPay(){
      let obj = []
      for(let i = 0; i < this.timeArr.length; i ++){
        obj.push({beginTime: moment(parseInt(this.timeArr[i])).format("X"), endTime: moment(parseInt(this.timeArr[i])).add(1,'h').format("X"), courseId: this.courseIds[i], courseName: this.courseList.find(item => item.courseId === this.courseIds[i]).courseName, courseCount: 1})
      }
      const res = await orderCourse({teacherId: this.info.teacherId, products: JSON.stringify(obj), payChannel: this.type})
      if(res.data.status === 1){
        res.data.data.payPwd = this.psw
        const res2 = await payOrder(res.data.data)
        if(res2.data.status === 1){
          if(this.type === 'balance'){
            this.$message({message: '预约成功', type: "success"})
            this.$parent.showPop = false
            this.$router.push({path: '/teachers/appointment', query: {id: this.info.teacherId}})
          }else{
            console.log(res.data)
            window.location.href = res2.data.data.approveUrl
          }
        }
      }
    },
    closePop(){
      this.$parent.showPop = false
    }
  }
}
</script>
<style lang="scss" scoped>
.ui-modal{
  padding: 60px 135px 0; height: 400px; 
  input{
    background: #ededed; width: 100%; height: 42px; line-height: 40px; border-radius: 42px; border: 1px solid #ededed; padding: 0 22px; margin-top: 67px;
    &:focus{border-color: #002147;}
  }
}
.title{font-size: 20px; line-height: 27px; text-align: center;}
.btns{margin-top: 67px; .ui-btn{margin: 0 10px;}}
</style>
<i18n>
{
  "cn": {
    "go": "去支付",
    "tip": "请输入支付密码"
  },
  "TW": {
    "go": "去支付",
    "tip": "請輸入支付密碼"
  },
  "en": {
    "go": "Pay",
    "tip": "Please enter payment password"
  }
}
</i18n>